export interface InputPlaceholderProps {
  text: string;
  className?: string;
}

export const INPUT_PLACEHOLDER_CLASS = 'CustomInputPlaceholder';
